// converts resx to tabular data, ie array of objects { group: string, key: string, value: string }
const processResx = (resx) => {
  const data = []
  for (const group in resx) {
    for (const key in resx[group]) {
      data.push({ group, key, valueEn: resx[group][key].en, valueAr: resx[group][key].ar })
    }
  }
  return data
}

const prepareDataForGroupEnumFilter = (resx) => {
  const data = []
  if (resx) {
    for (const key in resx) { data.push({ value: key, text: key }) }
  }
  return data
}

export { processResx, prepareDataForGroupEnumFilter }



// WEBPACK FOOTER //
// ./src/internal-app/components/administration/resources/Resources.DataSource.js